import remote from '../remote'

const state = {
  invoiceDmts: []
}

const getters = {
  INVOICE_DMTS: (state, getters) => {
    return state.invoiceDmts
  },
  INVOICE_DMTS_BY_ID: (state, getters) => (id) => {
    return state.invoiceDmts.find(dmt => dmt.id === id)
  },
  INVOICE_DMTS_BY_STRING: (state, getters) => (str) => {
    return state.invoiceDmts.find(dmt => dmt.data.dmtString === str)
  }
}

const mutations = {
  ADD_INVOICE_DMT: (state, payload) => {
    state.invoiceDmts.push(payload)
  },
  SET_INVOICE_DMT: (state, payload) => {
    state.invoiceDmts = [
      ...state.invoiceDmts.map(item => item.id !== payload.id ? item : { ...item, ...payload })
    ]
  },
  SET_INVOICE_DMTS: (state, payload) => {
    state.invoiceDmts = payload
  },
  REMOVE_INVOICE_DMT: (state, payload) => {
    const i = state.invoiceDmts.map(item => item.id).indexOf(payload)
    state.invoiceDmts.splice(i, 1)
  }
}

const actions = {
  GET_INVOICE_DMTS: async (context, payload) => {
    const { data } = await remote().get('/api/invoiceDmts')
    context.commit('SET_INVOICE_DMTS', data)
  },
  CREATE_INVOICE_DMT: async (context, payload) => {
    const { data } = await remote().post('/api/invoiceDmts', { invoiceDmt: payload })
    context.commit('ADD_INVOICE_DMT', data)
  },
  SET_INVOICE_DMT: async (context, payload) => {
    const { data } = await remote().put('/api/invoiceDmts/' + payload.id, { invoiceDmt: payload })
    context.commit('SET_INVOICE_DMT', data)
  },
  DELETE_INVOICE_DMT: async (context, payload) => {
    await remote().delete('/api/invoiceDmts/' + payload)
    context.commit('REMOVE_INVOICE_DMT', payload)
  }
}

export default {
  state, getters, mutations, actions
}



// WEBPACK FOOTER //
// ./src/modules/invoicedmts.js